import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-reason-dialog',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './reason-dialog.component.html',
  styleUrl: './reason-dialog.component.scss'
})
export class ReasonDialogComponent {
constructor(
  private dialogRef: MatDialogRef<ReasonDialogComponent>,
  @Inject (MAT_DIALOG_DATA) public data: any
){}

closeDialog(){
  this.dialogRef.close()
}
}
